import { ICreditLineDetails } from "@/apps/credit-line/models/CreditLineDetails";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";

export const checkDelinquency = (summary: ICreditLineDetails): boolean => {
  if (!summary) {
    DatadogLogger.Log(
      "checkDelinquency: summary is null or undefined",
      {},
      LogType.WARN
    );
    return true;
  }

  const isValidThrough =
    Boolean(summary.currentPeriodValidThrough) &&
    summary.currentPeriodValidThrough * 1000 > Date.now();
  const hasZeroBalance = Number(summary.currentPeriodBalance) === 0;

  return !(isValidThrough || hasZeroBalance);
};
